import { FC, useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import ArrowLeftIcon from './icons/ArrowLeft';

const BackToContainer = styled.div`
  stroke: var(--gray-900);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  height: 100%;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 10vh;
  margin-bottom: 5rem;
  max-width: 100%;
  align-self: center;
`;

const LogosContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  svg {
    transform: scale(2);
  }
  margin-bottom: 12vh;
`;

const IconContainer = styled.div`
  position: relative;
  width: 1.25rem;
  stroke: var(--gray-900);
  svg {
    width: 1.25rem;
    position: absolute;
    top: -2rem;
  }
`;

const Title = styled.h1`
  position: relative;
  color: black;
  font-size: 1.5rem;
  width: 100%;
  text-align: center;
  padding: 0 2rem;
`;

const Subtitle = styled.p`
  margin-top: 0.75rem;
  color: var(--gray-500);
  font-size: 1rem;
  text-align: center;
  width: min(80%, 18rem);
`;

type Props = {
  title?: string;
  subtitle?: string;
  icon?: React.ReactElement;
  backTo?: string;
  src_image: string;
};
const AuthenticationLayout: FC<Props> = ({
  title,
  subtitle,
  icon,
  backTo,
  src_image,
  children,
}) => {
  const [searchParams] = useSearchParams();
  const to: string | undefined = useMemo(() => {
    return searchParams.get('from') || backTo;
  }, [searchParams, backTo]);
  return (
    <Container>
      <LogosContainer>
        <img
          src={src_image}
          alt="Logo Institut de l'Engagement"
          height="100"
        />
      </LogosContainer>
      {icon && <IconContainer>{icon}</IconContainer>}
      <Title>
        {title}
        {backTo && (
          <BackToContainer>
            <Link to={to!}>
              <ArrowLeftIcon />
            </Link>
          </BackToContainer>
        )}
      </Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
      {children}
    </Container>
  );
};

export default AuthenticationLayout;
